var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5997L9.2998 9.2998C11.1223 7.4774 11.1223 4.52261 9.2998 2.70017C7.4774 0.87772 4.52261 0.87772 2.70017 2.70017C0.87772 4.52261 0.87772 7.4774 2.70017 9.2998L6 12.5997ZM6 14.4853L1.75736 10.2427C-0.585787 7.89947 -0.585787 4.10051 1.75736 1.75736C4.10051 -0.585787 7.89947 -0.585787 10.2427 1.75736C12.5858 4.10051 12.5858 7.89947 10.2427 10.2427L6 14.4853ZM6 7.33333C6.7364 7.33333 7.33333 6.7364 7.33333 6C7.33333 5.26362 6.7364 4.66667 6 4.66667C5.2636 4.66667 4.66667 5.26362 4.66667 6C4.66667 6.7364 5.2636 7.33333 6 7.33333ZM6 8.66667C4.52724 8.66667 3.33333 7.47273 3.33333 6C3.33333 4.52724 4.52724 3.33333 6 3.33333C7.47273 3.33333 8.66667 4.52724 8.66667 6C8.66667 7.47273 7.47273 8.66667 6 8.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location-pin-icon.5029fae4c78a821e85785021a722bc8b.svg";
export { ForwardRef as ReactComponent };